import React, { useState, useContext } from "react";
import { NavigationContext } from "navigation-react";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardRequestContent from "./DashboardRequestContent";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import "../src/styles.css";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes" });

const UltrasoundDashboard = () => {
  const [loading, setLoading] = useState(false);
  const { stateNavigator } = useContext(NavigationContext);
  const [token, setToken] = useState("");

  const username = ls.get("username");

  const handleLogout = async () => {
    setLoading(true);
    try {
      const csrfResponse = await fetch(`${process.env.REACT_APP_SESSION_TOKEN_URL}`, {
        method: "GET",
        credentials: "include",
        headers: { Accept: "application/json" },
      });

      if (!csrfResponse.ok) {
        throw new Error("Failed to fetch CSRF token");
      }

      const tokenText = await csrfResponse.text();
      console.log("CSRF Token:", tokenText);
      setToken(tokenText);

      const response = await fetch(`/user/logout?_format=json&token=${token}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        console.log("Logout successful");
        ls.clear();
        stateNavigator.navigate("login");
      } else {
        throw new Error("Logout failed");
      }
    } catch (error) {
      console.error("Error during logout:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loadingindicator">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <DashboardContentHeader handleLogout={handleLogout} username={username} />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <DashboardRequestContent
          className="content-box"
          iconImage={faUserPlus}
        />
      </div>
      <DashboardContentFooter />
    </div>
  );
};

export default UltrasoundDashboard;
